module.exports = __webpack_public_path__ + "media/images/logo_3x-118f5ad7ab43f6567dde902b15742f2c.png";